import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { PackBento } from "./components/PackBento";
import { HowItWorks } from "./components/HowItWorks";
import { CottonInserts } from "./components/CottonInserts";
import { ComfortRange } from "./components/ComfortRange";
import { Colours } from "./components/Colours";
import { Shop } from "./components/Shop";
import { Safety } from "./components/Safety";
import { SaferSleep } from "./components/SaferSleep";
import { Retailers } from "./components/Retailers";
import { RegisterInterest } from "./components/RegisterInterest";
import { Footer } from "./components/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div id="top" className="App min-h-screen overflow-x-hidden bg-[#FBFDFF] font-body text-slate-900 antialiased">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <PackBento />
        <HowItWorks />
        <CottonInserts />
        <ComfortRange />
        <Colours />
        <Shop />
        <Safety />
        <SaferSleep />
        <Retailers />
        <RegisterInterest />
      </main>
      <Footer />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
